import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const navigate = useNavigate();

  // Clear fields on component mount
  useEffect(() => {
    setEmail('');
    setPassword('');
    setLoginError('');
  }, []);

  const validateForm = () => {
    if (!email || !password) {
      setLoginError('Email and password are required.');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError(''); // Clear previous errors

    if (validateForm()) {
      if (!API_BASE_URL) {
        setLoginError('Server configuration error. Please contact support.');
        return;
      }

      try {
        const response = await fetch(`${API_BASE_URL}/api/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ Username: email, Password: password }),
        });

        const data = await response.json();

        console.log('Response Status:', response.status);
        console.log('API Response:', data);

        if (response.ok && data.token) {
          // Save user details in localStorage
          localStorage.setItem('loggedInUserEmail', email);
          // localStorage.setItem('role', data.role);
          localStorage.setItem('token', data.token);
          localStorage.setItem('userid', data.userid);
          localStorage.setItem('fullname', data.fullname);
          localStorage.setItem('usertype', data.usertype);

          // alert('Login Successful!');
          setEmail('');
          setPassword('');

          // Simplified navigation logic based on role
          if (data.usertype === 'Admin') {
            navigate('/sales-dashboard');
          }
          // } else if (data.usertype === 'Sales Admin') {
          //   navigate('/sales-dashboard');
          // } 
            else if (data.usertype === 'Team') {
            navigate('/team-dashboard');
          } else if (data.usertype === 'Partners') {
            navigate('/partners-dashboard');
          }else {
            setLoginError(data.message || 'Invalid credentials');
          }
        } else {
          setLoginError(data.message || 'Invalid credentials');
        }
      } catch (error) {
        setLoginError('An error occurred. Please try again later.');
      }
    }
  };

  return (
    <div>
      <Navbar />
      <div className="login-container">
        <div className="title">
          <img src="/log.png" alt="Login" />
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          <div>
            <label>Email</label>
            <input
              className="input-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email"
            />
          </div>
          <div>
            <label>Password</label>
            <input
              className="input-pass"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />
          </div>
          <button className="login-button" type="submit">
            Login
          </button>
          {loginError && <p style={{ color: 'red' }}>{loginError}</p>}
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default LoginForm;
